import service from '@/request/http.js'

export const GetPageAppointDataList = (data) => {
	return service({
		url: '/Chart/GetPageAppointDataList',
		method: 'post',
		data
	})
};

export const GetPagesxAppointDataList = (data) => {
	return service({
		url: '/Chart/GetPagesxAppointDataList',
		method: 'post',
		data
	})
};

//实训记录
export const GetPageTrainDataList = (data) => {
	return service({
		url: '/Chart/GetPageTrainDataList',
		method: 'post',
		data
	})
};

// 
export const GetPageTrainDataListApi = (data) => {
	return service({
		url: '/Model/GetPageTrainDataList',
		method: 'post',
		data
	})
};


// 设备不分页
export const GetyyTrainEquipmentList = (data) => {
	return service({
		url: '/TrainEquipment/GetTrainEquipmentList?si_guid=' + data,
		method: 'get'
	})
};

export const GetyyGetTrainList = (data) => {
	return service({
		url: '/Train/GetTrainList?si_guid=' + data,
		method: 'get'
	})
};

// 班级不分页
export const GetyyGetClassList = (data) => {
	return service({
		url: '/ClassInfo/GetClassList?si_guid=' + data,
		method: 'get'
	})
};

export const GetrzPageLogList = (data) => {
	return service({
		url: '/Log/GetPageLogList?pageIndex=' + data.pageIndex + "&pageSize=" + data.pageSize +
			"&log_typeName=" + data.log_typeName + "&st=" + data.st + "&et=" + data.et,
		method: 'get'
	})
};

// 数据统计分析
export const GetchatChartIndex = (data) => {
	return service({
		url: '/Chart/ChartIndex?si_guid=' + data,
		method: 'get'
	})
};

// 数据班级
export const GetdataPageClassSTAList = (data) => {
	return service({
		url: '/Chart/GetPageClassSTAList?pageIndex=' + data.pageIndex + "&pageSize=" + data.pageSize +
			"&si_guid=" + data.si_guid + "&cla_name=" + data.cla_name,
		method: 'get'
	})
};

export const GetdataClassStuinfoList = (data) => {
	return service({
		url: '/Chart/GetClassStuinfoList?cla_guid=' + data.cla_guid + "&ui_realName=" + data.ui_realName,
		method: 'get'
	})
};


// 单个设备使用情况


export const GetWeekEquipmentUsage = (data) => {
	return service({
		url: '/Chart/GetWeekEquipmentUsage?sx_te_guid=' + data.sx_te_guid + "&time=" + data.time,
		method: 'get'
	})
};


export const GetsyEquipmentUsage = (data) => {
	return service({
		url: '/Chart/GetEquipmentUsage?sx_te_guid=' + data.sx_te_guid + "&month=" + data.month,
		method: 'get'
	})
};

export const GetsbEquipmentTrainSTA = (data) => {
	return service({
		url: '/Model/GetEquipmentTrainSTA?sx_te_guid=' + data.sx_te_guid + "&year=" + data.year,
		method: 'get'
	})
};
	
// 日历设备数据分析
export const GetsbTrainEquipmentAppoint = (data) => {
	return service({
		url: '/Chart/GetTrainEquipmentAppoint?sx_te_guid=' + data.sx_te_guid + "&startTime=" + data
			.startTime + "&endTime=" + data.endTime,
		method: 'get'
	})
};

// 根据日期选择成员
export const GetsbTrainAppointList = (data) => {
	return service({
		url: '/Chart/GetTrainAppointList?sx_te_guid=' + data.sx_te_guid + "&ap_appDate=" + data.ap_appDate +
			"&ui_realName=" + data.ui_realName,
		method: 'get'
	})
};

// 班级数据分析
export const GetbjClassInfo = (data) => {
	return service({
		url: '/Chart/GetClassInfo?cla_guid=' + data,
		method: 'get'
	})
};

export const GetbjClassInfoSTA = (data) => {
	return service({
		url: '/Chart/GetClassInfoSTA?cla_guid=' + data.cla_guid + "&startTime=" + data.startTime +
			"&endTime=" + data.endTime + "&sx_te_guid=" + data.sx_te_guid,
		method: 'get'
	})
};
// model
export const GetClassInfoSTAModelApi = (data) => {
	return service({
		url: '/Model/GetClassInfoSTA?cla_guid=' + data.cla_guid + "&startTime=" + data.startTime +
			"&endTime=" + data.endTime + "&sx_te_guid=" + data.sx_te_guid,
		method: 'get'
	})
};


export const GetClassInfoComprehensiveScoreSTA = (data) => {
	return service({
		url: '/Chart/GetClassInfoComprehensiveScoreSTA?cla_guid=' + data.cla_guid + "&sx_te_guid=" + data
			.sx_te_guid + "&taskName=" + data.taskName + "&startTime=" + data.startTime + "&endTime=" + data
			.endTime,
		method: 'get'
	})
};

export const ModelGetClassInfoComprehensiveScoreSTAPI = (data) => {
	return service({
		url: '/Model/GetClassInfoComprehensiveScoreSTA?cla_guid=' + data.cla_guid + "&sx_te_guid=" + data
			.sx_te_guid + "&taskName=" + data.taskName + "&startTime=" + data.startTime + "&endTime=" + data
			.endTime,
		method: 'get'
	})
};




export const GetClassInfoTainTimeLengthSTA = (data) => {
	return service({
		url: '/Chart/GetClassInfoTainTimeLengthSTA?cla_guid=' + data.cla_guid + "&timetype=" + data
			.timetype + "&parms=" + data.parms,
		method: 'get'
	})
};

export const ModelGetClassInfoTainTimeLengthSTAPI = (data) => {
	return service({
		url: '/Model/GetClassInfoTainTimeLengthSTA?cla_guid=' + data.cla_guid + "&timetype=" + data
			.timetype + "&parms=" + data.parms + "&sx_te_guid=" + data.sx_te_guid,
		method: 'get'
	})
};



export const GetClassInfoTainTimeLengthSTApi = (data) => {
	return service({
		url: '/Model/GetClassInfoTainTimeLengthSTA?cla_guid=' + data.cla_guid + "&timetype=" + data
			.timetype + "&parms=" + data.parms + "&sx_te_guid=" + data.sx_te_guid,
		method: 'get'
	})
};


export const GetClassInfoTainScoreSTA = (data) => {
	return service({
		url: '/Chart/GetClassInfoTainScoreSTA?cla_guid=' + data.cla_guid + "&month=" + data.month,
		method: 'get'
	})
};

export const GetClassInfoTainScoreSTAPI = (data) => {
	return service({
		url: '/Model/GetClassInfoTainScoreSTA?cla_guid=' + data.cla_guid + "&month=" + data.month,
		method: 'get'
	})
};

// 预约
export const AppointmentOnAudit = (data) => {
	return service({
		url: '/Appointment/OnAudit?',
		method: 'post',
		data
	})
};


// 删除日志
export const DeleteLog = (data) => {
	return service({
		url: '/Log/Delete?log_guid=' + data,
		method: 'get'
	})
};

//用户考勤认证列表 http://localhost:44354/api/user/GetPageUserlogList
export const GetPageUserlogList = (data) => {
	return service({
		//http://localhost:44354/api/user/GetPageUserlogList?pageIndex=1&pageSize=10&ui_userName=&si_guid=
		url: '/user/GetPageUserlogList?pageIndex=' + data.pageIndex + "&pageSize=" + data.pageSize +
			"&ui_userName=" + data.ui_userName + "&si_guid=" + data.si_guid + "&cla_guid=" + data.cla_guid,
		method: 'get'
	})
};



// 能力掌握程度
export const GetMyClatypeTrainDataApi = (data) => {
	return service({
		url: '/Model/GetMyClatypeTrainData?cla_guid=' + data.cla_guid + "&sx_te_guid=" + data.sx_te_guid,
		method: 'get'
	})
};